import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// --- 1. Element Plus ---
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

// --- 2. 粒子特效 ---
import Particles from "particles.vue3";

// --- 3. AOS 滚动动画库 ---
import AOS from 'aos'
import 'aos/dist/aos.css'

// --- 【新增】 4. 导入翻译插件 ---
import i18n from './lang'

const app = createApp(App)

app.use(router)
app.use(ElementPlus)
app.use(Particles)
app.use(i18n) // --- 【新增】 挂载翻译插件 ---

// 初始化 AOS (mount 之后)
app.mount('#app')

AOS.init({
  offset: 100,
  duration: 800,
  easing: 'ease-out-cubic',
  delay: 100,
  once: false,
});